import { createTheme } from '@mui/material/styles';

const monokaiTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#f92672', // Monokai red for primary elements
    },
    secondary: {
      main: '#ae81ff', // Monokai purple for secondary elements
    },
    background: {
      default: '#1e1e1e', // Very dark background
      paper: '#252525', // Dark background for menus
    },
    text: {
      primary: '#f8f8f2', // Bright text
      secondary: '#75715e', // Muted text
    },
  },
  typography: {
    fontFamily: "'Lucida Grande', 'Helvetica Neue', Arial, sans-serif",
  },
  components: {
    MuiMenu: {
      styleOverrides: {
        paper: {
          '&.toolbar-menu': {
            backgroundColor: '#1e1e1e', // Flush background for toolbar menus
            color: '#f8f8f2', // Bright text
            boxShadow: 'none', // Remove shadow for toolbar menus
            borderRadius: 0, // No rounded corners
            padding: 0, // Remove extra padding
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.toolbar-menu-item': {
            backgroundColor: 'transparent', // No button-like background
            color: '#f8f8f2', // Bright text
            padding: '16px 24px', // Larger padding for XL items
            fontSize: '18px', // Larger font size for XL items
            borderBottom: '1px solid #252525', // Separator for toolbar items
            '&:last-child': {
              borderBottom: 'none', // Remove separator for the last item
            },
            '&:hover': {
              backgroundColor: '#3e3d32', // Subtle hover effect
            },
          },
        },
      },
    },
  },
});

export default monokaiTheme;
